import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('data', 'otpAuthCodes');
export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'otp_auth',
  type: 'post',
  slug: ['codes'],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/data/optAuthCodes.js